// The screens this app has, generated from .appfactory/product-plan.json.
//
// Imported by the navigation shell rather than replacing it: the shell owns
// router.js — bottom-tabs, stack and sidebar produce different routers, and it
// rewrites that file on every `spec apply`. Two owners for one file is a silent
// fight, so the product contributes ROUTES and the shell decides what to do
// with them.
//
// `primary` marks a screen that earns a place in the navigation itself.

import NowPage from './pages/NowPage.vue';
import RadarPage from './pages/RadarPage.vue';
import WeekPage from './pages/WeekPage.vue';
import SettingsPage from './pages/SettingsPage.vue';
import WarningDetailPage from './pages/WarningDetailPage.vue';

export const PRODUCT_ROUTES = [
  {
    id: 'now',
    path: '/',
    label: 'Now',
    component: NowPage,
    primary: true,
  },
  {
    id: 'radar',
    path: '/radar',
    label: 'Radar',
    component: RadarPage,
    primary: false,
  },
  {
    id: 'week',
    path: '/week',
    label: 'Week',
    component: WeekPage,
    primary: false,
  },
  {
    id: 'settings',
    path: '/settings',
    label: 'Settings',
    component: SettingsPage,
    primary: false,
  },
  {
    id: 'warning-detail',
    path: '/warnings/:id',
    label: 'Warning',
    component: WarningDetailPage,
    primary: false,
  },
];

export const PRIMARY_ROUTES = PRODUCT_ROUTES.filter((r) => r.primary);
export const HOME_ROUTE = (PRIMARY_ROUTES[0] ?? PRODUCT_ROUTES[0])?.path ?? '/';
